var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticClass: "subject" }, [
      _c("div", { staticClass: "subject-title" }, [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.title,
              expression: "title",
            },
          ],
          staticClass: "underline input-style",
          attrs: { placeholder: "標題", disabled: !_vm.isEdit },
          domProps: { value: _vm.title },
          on: {
            input: function ($event) {
              if ($event.target.composing) return
              _vm.title = $event.target.value
            },
          },
        }),
      ]),
      _c("aside", { staticClass: "subject-tools" }, [
        _c(
          "div",
          [
            !_vm.isEdit
              ? _c("eva-icon", {
                  staticClass: "icon",
                  attrs: { fill: "#5B5B5B", name: "edit-outline" },
                  on: {
                    click: function ($event) {
                      _vm.isEdit = true
                    },
                  },
                })
              : _vm._e(),
            _c("eva-icon", {
              staticClass: "icon",
              attrs: { fill: "#5B5B5B", name: "trash-2-outline" },
              on: { click: _vm.del },
            }),
          ],
          1
        ),
      ]),
    ]),
    _vm.hasDescription
      ? _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.description,
              expression: "description",
            },
          ],
          staticClass: "underline description-style",
          attrs: { placeholder: "備註說明", disabled: !_vm.isEdit },
          domProps: { value: _vm.description },
          on: {
            input: function ($event) {
              if ($event.target.composing) return
              _vm.description = $event.target.value
            },
          },
        })
      : _vm._e(),
    _vm.isEdit
      ? _c("div", { staticClass: "tag-group" }, [
          _c(
            "span",
            {
              staticClass: "badge tag",
              style: [
                _vm.isRequired
                  ? { background: "#3DBA90" }
                  : { background: "#BDBDBD" },
              ],
              on: {
                click: function ($event) {
                  _vm.isRequired = !_vm.isRequired
                },
              },
            },
            [
              _c("eva-icon", {
                staticClass: "icon",
                attrs: { fill: "#fff", name: "star-outline" },
              }),
              _c("span", [_vm._v("必填")]),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "badge tag",
              style: [
                _vm.hasDescription
                  ? { background: "#3DBA90" }
                  : { background: "#BDBDBD" },
              ],
              on: {
                click: function ($event) {
                  _vm.hasDescription = !_vm.hasDescription
                },
              },
            },
            [
              _c("eva-icon", {
                staticClass: "icon",
                attrs: { fill: "#fff", name: "message-square-outline" },
              }),
              _c("span", [_vm._v("備註")]),
            ],
            1
          ),
        ])
      : _vm._e(),
    _vm._m(0),
    _vm.isEdit
      ? _c("div", { staticClass: "button-group" }, [
          _c(
            "button",
            {
              staticClass: "btn btn-light btn-sm",
              attrs: { type: "button" },
              on: { click: _vm.cancel },
            },
            [_vm._v(" 取消 ")]
          ),
          _c(
            "button",
            {
              staticClass: "btn btn-info btn-sm",
              attrs: { type: "button" },
              on: { click: _vm.done },
            },
            [_vm._v(" 完成 ")]
          ),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "answer" }, [
      _c("input", { staticClass: "basic style", attrs: { disabled: "" } }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }